var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDesktop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.928,
    height: 32.213,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.476.1a.894.894 0 0 0-.325.316L.019.627.006 12.938c-.013 13.562-.031 12.507.255 12.8s-.413.277 8.433.277c7.106 0 8 .009 8 .066s-.343 4.426-.36 4.636l-.013.11-2.975.022c-3.573.026-3.221-.048-3.221.685v.475l.149.1.149.1h8.895c9.695 0 9.145.013 9.242-.242a2.092 2.092 0 0 0 0-.875c-.114-.242-.141-.246-3.182-.246-2.628 0-2.791 0-2.791-.079 0-.039-.079-1.055-.176-2.25s-.176-2.25-.176-2.342v-.163h7.989c7.629 0 7.994 0 8.161-.083a.906.906 0 0 0 .505-.628c.035-.171.044-3.423.035-12.45C38.912 1.566 38.907.625 38.837.502a1.133 1.133 0 0 0-.461-.435C38.248 0 36.653 0 19.452 0H.67zm37.469 12.907v11.756l-18.488.013-18.493.009V1.23l18.493.009 18.488.013z",
    "data-name": "Path 32",
    fill: "#8a8a8a"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktop);
export default __webpack_public_path__ + "static/media/desktop.c0a1ac66130dab5728f57399863af896.svg";
export { ForwardRef as ReactComponent };